import { jsxs as w, jsx as r } from "react/jsx-runtime";
import * as i from "react";
import { u as D } from "../index-BwdHfdWj.js";
import { c as M, a as j, b as R } from "../index-Dn5fq5RO.js";
import { u as A } from "../index-BZPx6jYI.js";
import { u as H } from "../index-BuFJZcOe.js";
import { P as K } from "../index-C7ixzbBF.js";
import { P as S } from "../index-Bo0P2KXg.js";
import { c as q } from "../index-Cu0xwYjD.js";
import { Icon as z } from "./Icon.js";
import { Link as F } from "./Link.js";
var I = "Checkbox", [T, le] = M(I), [X, $] = T(I), N = i.forwardRef(
  (e, d) => {
    const {
      __scopeCheckbox: t,
      name: s,
      checked: a,
      defaultChecked: o,
      required: h,
      disabled: n,
      value: m = "on",
      onCheckedChange: C,
      form: f,
      ...v
    } = e, [l, x] = i.useState(null), y = D(d, (c) => x(c)), _ = i.useRef(!1), E = l ? f || !!l.closest("form") : !0, [k = !1, P] = j({
      prop: a,
      defaultProp: o,
      onChange: C
    }), B = i.useRef(k);
    return i.useEffect(() => {
      const c = l == null ? void 0 : l.form;
      if (c) {
        const p = () => P(B.current);
        return c.addEventListener("reset", p), () => c.removeEventListener("reset", p);
      }
    }, [l, P]), /* @__PURE__ */ w(X, { scope: t, state: k, disabled: n, children: [
      /* @__PURE__ */ r(
        S.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(k) ? "mixed" : k,
          "aria-required": h,
          "data-state": O(k),
          "data-disabled": n ? "" : void 0,
          disabled: n,
          value: m,
          ...v,
          ref: y,
          onKeyDown: R(e.onKeyDown, (c) => {
            c.key === "Enter" && c.preventDefault();
          }),
          onClick: R(e.onClick, (c) => {
            P((p) => u(p) ? !0 : !p), E && (_.current = c.isPropagationStopped(), _.current || c.stopPropagation());
          })
        }
      ),
      E && /* @__PURE__ */ r(
        G,
        {
          control: l,
          bubbles: !_.current,
          name: s,
          value: m,
          checked: k,
          required: h,
          disabled: n,
          form: f,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(o) ? !1 : o
        }
      )
    ] });
  }
);
N.displayName = I;
var g = "CheckboxIndicator", L = i.forwardRef(
  (e, d) => {
    const { __scopeCheckbox: t, forceMount: s, ...a } = e, o = $(g, t);
    return /* @__PURE__ */ r(K, { present: s || u(o.state) || o.state === !0, children: /* @__PURE__ */ r(
      S.span,
      {
        "data-state": O(o.state),
        "data-disabled": o.disabled ? "" : void 0,
        ...a,
        ref: d,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
L.displayName = g;
var G = (e) => {
  const { control: d, checked: t, bubbles: s = !0, defaultChecked: a, ...o } = e, h = i.useRef(null), n = A(t), m = H(d);
  i.useEffect(() => {
    const f = h.current, v = window.HTMLInputElement.prototype, x = Object.getOwnPropertyDescriptor(v, "checked").set;
    if (n !== t && x) {
      const y = new Event("click", { bubbles: s });
      f.indeterminate = u(t), x.call(f, u(t) ? !1 : t), f.dispatchEvent(y);
    }
  }, [n, t, s]);
  const C = i.useRef(u(t) ? !1 : t);
  return /* @__PURE__ */ r(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: a ?? C.current,
      ...o,
      tabIndex: -1,
      ref: h,
      style: {
        ...e.style,
        ...m,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function u(e) {
  return e === "indeterminate";
}
function O(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var J = N, Q = L;
const U = "_checkboxOption_11wk1_1", V = "_onlyButton_11wk1_7", W = "_checkbox_11wk1_1", Y = "_checkboxIndicator_11wk1_78", Z = "_checkboxLabel_11wk1_83", b = {
  checkboxOption: U,
  onlyButton: V,
  checkbox: W,
  checkboxIndicator: Y,
  checkboxLabel: Z
}, ue = ({
  className: e,
  option: d,
  onValueChange: t,
  onOnlyClick: s,
  checked: a,
  label: o,
  disabled: h = !1,
  id: n
}) => /* @__PURE__ */ w(
  "label",
  {
    className: q(
      b.checkboxOption,
      a && b.checkboxOptionChecked,
      e
    ),
    htmlFor: n,
    children: [
      /* @__PURE__ */ r(
        J,
        {
          disabled: h,
          onClick: () => t(!a, d),
          checked: a,
          className: b.checkbox,
          id: n,
          children: /* @__PURE__ */ r(Q, { className: b.checkboxIndicator, children: z.statusSuccessIcon })
        }
      ),
      /* @__PURE__ */ r("div", { className: b.checkboxLabel, children: o }),
      s && /* @__PURE__ */ r(F, { linkStyle: "secondary", asChild: !0, children: /* @__PURE__ */ r(
        "button",
        {
          className: b.onlyButton,
          onClick: () => s(d),
          children: "only"
        }
      ) })
    ]
  }
);
export {
  ue as Checkbox
};
